import { configureStore } from '@reduxjs/toolkit';
import visualReducer from '../features/tableData/visualSlice';

export default configureStore({
  reducer: {
    visual: visualReducer,
  },
});
